import SellerBadge from 'domains/seller/atoms/seller-badge'
import PropTypes from 'prop-types'
import React from 'react'
import { Card, CardFooter, Table } from 'reactstrap'

const propTypes = {
  seller: PropTypes.shape({
    name             : PropTypes.string,
    gender           : PropTypes.string,
    seller_type      : PropTypes.string,
    code             : PropTypes.string,
    username         : PropTypes.string,
    mobile           : PropTypes.string,
    email            : PropTypes.string,
    street_address   : PropTypes.string,
    kecamatan        : PropTypes.string,
    kelurahan        : PropTypes.string,
    kota             : PropTypes.string,
    provinsi         : PropTypes.string,
    kode_pos         : PropTypes.string,
    is_banned        : PropTypes.bool,
    is_banned_reason : PropTypes.string
  }),
  children   : PropTypes.any,
  tableProps : PropTypes.object,
  cardProps  : PropTypes.object
}

const defaultProps = {
  tableProps: {
    className  : 'mb-0',
    size       : 'sm',
    responsive : true ,
    hover      : true
  }
}

/**
 * Display seller details in a card
 * @param {object} seller -  seller object
 * @param {object} cardProps -  custom seller card props
 * @param {object} tableProps -  custom table props
 * @param {React.FunctionComponent} children -  components to render below the table
 */
const SellerCard = ({
  seller,
  children,
  tableProps,
  cardProps
}) => (
  <Card { ...cardProps }>
    <div className='p-2'>
      <span className='small text-uppercase text-light font-weight-bold mr-3'>Seller</span>
      <SellerBadge className='badge-sm' seller_type={ seller.seller_type } />
      <div className='mr-3 font-weight-bold'>{ seller.name }</div>
    </div>

    <Table { ...tableProps }>
      <tbody>
        <tr>
          <th scope='row'>Gender</th>
          <td>{ seller.gender }</td>
        </tr>
        <tr>
          <th scope='row'>Code</th>
          <td>{ seller.code }</td>
        </tr>
        <tr>
          <th scope='row'>Username</th>
          <td>{ seller.username }</td>
        </tr>
        <tr>
          <th scope='row'>Phone</th>
          <td>{ seller.mobile }</td>
        </tr>
        <tr>
          <th scope='row'>Email</th>
          <td>{ seller.email }</td>
        </tr>
        <tr>
          <th scope='row'>Banned</th>
          <td>{ seller.is_banned ? 'Yes' : 'No' }</td>
        </tr>
        {
          seller?.is_banned && (
            <tr>
              <th scope='row'>Banned Reason</th>
              <td>{ seller.is_banned_reason }</td>
            </tr>
          )
        }
      </tbody>
    </Table>
    {
      children && (
        <CardFooter>
          { children }
        </CardFooter>
      )
    }
  </Card>
)

SellerCard.propTypes    = propTypes
SellerCard.defaultProps = defaultProps

export default SellerCard